<template>
  <div class="more-survey" v-loading="!hasMoreList">
    <div class="px-6">
      <div class="mb-3 leading-22 flex justify-between items-center">
        <span class="font-bold">更多问卷</span>
        <span class="cursor-pointer" @click="onToTask">
          <i class="el-icon-right"></i>
        </span>
      </div>
      <ul v-if="hasMoreList">
        <li v-for="item in moreSurveyList" :key="item.surveyId" class="survey-item cursor-pointer">
          <div class="flex justify-between leading-22 flex-1" @click="openStartSurvey(item)">
            <span class="truncate flex-1">
              {{ item.title }}
            </span>
            <span class="survey-price" v-if="item.amount">
              ￥{{ item.amount ? item.amount.toFixed(2) : '0.00' }}
            </span>
            <span class="survey-price text-medium" v-else>
              可抽奖
            </span>
          </div>
        </li>
      </ul>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="384px">
      <p class="text-center opacity-85 font-semibold text-20 mb-4">此问卷为第三方问卷</p>
      <p class="text-center text-theme-black-450 text-medium leading-20">参与答题即可获得 <span class="text-danger">{{ curItem.partakeAmount || '0' }}</span> 元红包奖励</p>
      <p class="text-center text-theme-black-450 text-medium leading-20">完成答题后可获得 <span class="text-danger">{{ curItem.amount || '0' }}</span> 元红包奖励</p>
      <p class="text-center text-theme-black-250 text-medium leading-20">注：奖励不可兼得</p>
      <span slot="footer" class="dialog-footer block w-full text-center pb-3">
        <el-button type="primary" @click="onStartSurvey(curItem)">立即答题</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { busGetters } from 'dygc'

export default {
  name: 'MoreSurvey',
  data() {
    return {
      dialogVisible: false,
      curItem: {}
    }
  },
  computed: {
    hasMoreList() {
      return !!this.moreSurveyList
    },
    ...busGetters(['moreSurveyList'])
  },
  methods: {
    openStartSurvey(item){
      if(item.isThirdParty) {
        this.curItem = item
        this.dialogVisible = true
      }else {
        this.$answerUtil.onStartMoreSurvey(item)
      }
    },
    onStartSurvey(item) {
      this.$answerUtil.onStartMoreSurvey(item)
    },
    onToTask() {
      window.location.replace(process.env.VUE_APP_TASK_HALL)
    }
  }
}
</script>
<style scoped lang="scss">
 ::v-deep .el-dialog__body {
   padding: 18px 0 22px 0;
 }
</style>